import {
	EngagementSpotlight,
	EngagementInlineDialog,
	Coordination,
	useCoordination,
} from '@atlassiansox/engagekit-ts';

import type {
	CoordinationClient,
	EngagementPlatformPluginOptions,
} from '@atlaskit/editor-plugin-engagement-platform';

interface Props {
	options: {
		coordinationClient: CoordinationClient;
	};
}

export function engagementPlatformPluginOptions({
	options,
}: Props): EngagementPlatformPluginOptions {
	return {
		epComponents: {
			EngagementSpotlight,
			EngagementInlineDialog,
			Coordination,
		},
		epHooks: {
			useCoordination,
		},
		coordinationClient: options.coordinationClient,
	};
}
